const translations = new Map([
  ['en', require('./en.json')],
  ['id', require('./id.json')]
]);

export default translations;
